import { IntegrationPartners } from '@/integrations/integration-constants';
import { LlmUtils } from '@/core/llm-utils';
import { getModule } from 'vuex-module-decorators';
import { AuthStore } from '@/store/auth-store';
import { BrandsStore } from '@/organizations/brands/store/brands-store';
import store from '@/store';
import { InterfaceSettingsStore } from '@/dashboards/store/interface-settings-store';
import { CentersStore } from '@/organizations/locations/stores/centers-store';

const llmUtils = new LlmUtils();
const authStore = getModule(AuthStore, store);
const brandsStore = getModule(BrandsStore, store);
const centerStore = getModule(CentersStore, store);
const settingsStore = getModule(InterfaceSettingsStore);

interface IntegrationLike {
    id: string | number;
    integration?: {
        values?: {
            name?: string;
        };
    };
}

async function initializeWhiteLabelUrl(): Promise<string> {
    if (settingsStore.hasWhiteLabel) {
        await brandsStore.init();
        await centerStore.initAccessibleCenters();
        const whitelabelUrl = llmUtils.getManageUrl(
            authStore.isCorporateUser,
            authStore.isCenterStaff,
            brandsStore.stored,
            centerStore.accessibleCenters
        );

        llmUtils.setBaseManageUrl(whitelabelUrl);
        return whitelabelUrl;
    }
    return llmUtils.getBaseManageUrl();
}

export async function getManageUrl(integrations: Array<IntegrationLike>, defaultUrl?: string): Promise<string> {
    await initializeWhiteLabelUrl();
    if (integrations?.length) {
        for (const integration of integrations) {
            if (integration?.integration?.values?.name === IntegrationPartners.MANAGE) {
                return llmUtils.getPersonUrl(String(integration.id));
            }
        }
    }
    return defaultUrl ?? llmUtils.getBaseManageUrl();
}

export function hasManageIntegration(integrations: Array<IntegrationLike>): boolean {
    if (integrations?.length) {
        for (const integration of integrations) {
            if (integration?.integration?.values?.name === IntegrationPartners.MANAGE) {
                return true;
            }
        }
    }
    return false;
}
